module.exports = __webpack_public_path__ + "img/header.344727fa.png";